import React, { type CSSProperties } from "react";
import type { ButtonKey } from "../../constants/gamepad";
import { ActionButton } from "./ActionButton";

import ActionAIcon1x from "../../assets/icons/action_button_A@1x.webp";
import ActionAIcon2x from "../../assets/icons/action_button_A@2x.webp";
import ActionAIcon3x from "../../assets/icons/action_button_A@3x.webp";
import ActionBIcon1x from "../../assets/icons/action_button_B@1x.webp";
import ActionBIcon2x from "../../assets/icons/action_button_B@2x.webp";
import ActionBIcon3x from "../../assets/icons/action_button_B@3x.webp";
import ActionYIcon1x from "../../assets/icons/action_button_Y@1x.webp";
import ActionYIcon2x from "../../assets/icons/action_button_Y@2x.webp";
import ActionYIcon3x from "../../assets/icons/action_button_Y@3x.webp";
import ActionXIcon1x from "../../assets/icons/action_button_X@1x.webp";
import ActionXIcon2x from "../../assets/icons/action_button_X@2x.webp";
import ActionXIcon3x from "../../assets/icons/action_button_X@3x.webp";

interface ActionButtonGroupProps {
  onTouchStart: (e: React.TouchEvent, buttonKey: ButtonKey) => void;
  onTouchEnd: (e: React.TouchEvent, buttonKey: ButtonKey) => void;
  onMouseDown: (e: React.MouseEvent, buttonKey: ButtonKey) => void;
  onMouseUp: (e: React.MouseEvent, buttonKey: ButtonKey) => void;
  buttons?: ButtonKey[];
  containerStyle?: CSSProperties;
  buttonStyles?: Partial<Record<ButtonKey, CSSProperties>>;
}

const buttonConfigs = {
  a: { src1x: ActionAIcon1x, src2x: ActionAIcon2x, src3x: ActionAIcon3x },
  b: { src1x: ActionBIcon1x, src2x: ActionBIcon2x, src3x: ActionBIcon3x },
  x: { src1x: ActionXIcon1x, src2x: ActionXIcon2x, src3x: ActionXIcon3x },
  y: { src1x: ActionYIcon1x, src2x: ActionYIcon2x, src3x: ActionYIcon3x },
};

const buttonPositions: Partial<Record<ButtonKey, CSSProperties>> = {
  y: { top: "0", left: "50%", transform: "translateX(-50%)" },
  b: { right: "0", top: "50%", transform: "translateY(-50%)" },
  a: { bottom: "0", left: "50%", transform: "translateX(-50%)" },
  x: { left: "0", top: "50%", transform: "translateY(-50%)" },
};

export const ActionButtonGroup: React.FC<ActionButtonGroupProps> = ({
  onTouchStart,
  onTouchEnd,
  onMouseDown,
  onMouseUp,
  buttons = ["a", "b", "x", "y"],
  containerStyle = {},
  buttonStyles = {},
}) => {
  return (
    <div style={{ ...baseStyles.actionButtonsContainer, ...containerStyle }}>
      {buttons.map((buttonKey) => {
        const config = buttonConfigs[buttonKey as keyof typeof buttonConfigs];
        if (!config) return null;

        return (
          <ActionButton
            key={buttonKey}
            buttonKey={buttonKey}
            iconConfig={config}
            onTouchStart={onTouchStart}
            onTouchEnd={onTouchEnd}
            onMouseDown={onMouseDown}
            onMouseUp={onMouseUp}
            containerStyle={{
              ...buttonPositions[buttonKey],
              ...buttonStyles[buttonKey],
            }}
          />
        );
      })}
    </div>
  );
};

const baseStyles: { [key: string]: CSSProperties } = {
  actionButtonsContainer: {
    position: "relative",
    width: 132,
    height: 132,
  },
};
